export default __webpack_public_path__ + "static/media/asyncapi_openapi.9c5e1766.yaml";